import styled, { css } from 'styled-components';

import { sizes } from '../../theme/sizes';

type GapSize = keyof typeof sizes;

export const SpaceBetween = styled.div<{ vertical?: boolean; center?: boolean; gapSize?: GapSize }>`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  min-width: 100%;

  ${({ vertical }) =>
    vertical &&
    css`
      flex-direction: column;
      min-height: 100%;
    `}

  ${({ center }) =>
    center &&
    css`
      align-items: center;
    `}

  ${({ gapSize }) =>
    gapSize &&
    css`
      gap: ${sizes[gapSize]};
    `}
`;
